import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fileUrl = (fileId) => `${API}/files/${fileId}`;

export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/uploads", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function createLetter(payload) {
  const { data } = await api.post("/letters", payload);
  return data; // { slug, manage_token, deliver_at }
}

export async function getLetter(slug) {
  const { data } = await api.get(`/letters/${slug}`);
  return data;
}

export async function trackOpen(slug, seconds) {
  return api.post(`/letters/${slug}/open`, { reading_seconds: seconds || 0 });
}

export async function trackReplay(slug) { return api.post(`/letters/${slug}/replay`); }
export async function trackSave(slug) { return api.post(`/letters/${slug}/save`); }
export async function trackShare(slug, channel) { return api.post(`/letters/${slug}/share`, { channel }); }

export async function reactToLetter(slug, reaction) {
  return api.post(`/letters/${slug}/reaction`, { reaction });
}

export async function fetchManage(slug, token) {
  const { data } = await api.get(`/letters/${slug}/manage`, { params: { token } });
  return data;
}

export async function adminLogin(username, password) {
  const { data } = await api.post("/admin/login", { username, password });
  return data.token;
}

export async function adminStats(token) {
  const { data } = await api.get("/admin/stats", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}
